import React from 'react'
import { StyledCheckbox, StyledCheckmark } from './styles'

interface Props {
  dataGa?: string
  disabled?: boolean
  label: string
  name?: string
  onChange: (value: boolean) => void
  required: boolean
  value: boolean
}

const Checkbox = ({ dataGa, label, onChange, value, disabled, name, required }: Props) => {
  const handleCheckedChange = (e) => {
    onChange(e.target.checked)
  }

  return (
    <StyledCheckbox $disabled={disabled}>
      <input
        checked={value}
        data-ga={dataGa}
        name={name}
        onChange={handleCheckedChange}
        required={required}
        type="checkbox"
      />
      <StyledCheckmark $checked={value} $disabled={disabled} />

      <p>{label}</p>
    </StyledCheckbox>
  )
}

export default Checkbox
